var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_331_15535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.7873 54.8948C59.642 60.0401 51.8894 60.6303 47.4718 56.2125C43.0539 51.7947 43.6441 44.0423 48.7894 38.897C52.6782 35.0082 58.0549 33.7219 62.3567 35.2311C63.0506 35.4746 63.8216 35.296 64.3224 34.757L88.0267 8.047C90.0867 5.72583 93.6763 5.61877 95.8708 7.81347C98.0653 10.008 97.9584 13.5976 95.6373 15.6576L68.9271 39.3619C68.388 39.8627 68.2094 40.6337 68.4529 41.3276C69.9624 45.6294 68.6761 51.006 64.7873 54.8948Z",
    fill: "url(#paint0_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2078 53.3143C59.08 57.4421 52.8608 57.9157 49.317 54.3719C45.7733 50.8282 46.2469 44.609 50.3747 40.4811C54.5025 36.3533 60.7218 35.8798 64.2655 39.4235C67.8092 42.9672 67.3359 49.1862 63.2078 53.3143Z",
    fill: "url(#paint1_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4715 56.2188C51.8893 60.6367 59.6417 60.0465 64.787 54.9012C68.3156 51.3725 69.7013 46.6188 68.8001 42.5547H46.0911C43.6237 47.2516 44.0109 52.7582 47.4715 56.2188Z",
    fill: "url(#paint2_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5896 33.3203C11.9268 33.3203 4.90332 40.3438 4.90332 49.0066C4.90332 57.6693 11.9268 64.6929 20.5896 64.6929C29.2523 64.6929 36.2759 57.6693 36.2759 49.0066C36.2759 40.3438 29.2523 33.3203 20.5896 33.3203ZM20.5896 59.3987C14.8504 59.3987 10.1974 54.7458 10.1974 49.0066C10.1974 43.2674 14.8504 38.6144 20.5896 38.6144C26.3288 38.6144 30.9818 43.2674 30.9818 49.0066C30.9818 54.7458 26.3288 59.3987 20.5896 59.3987Z",
    fill: "url(#paint3_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5921 35.6719C13.2274 35.6719 7.25879 41.6405 7.25879 49.0052C7.25879 56.3699 13.2274 62.3385 20.5921 62.3385C27.9568 62.3385 33.9255 56.3699 33.9255 49.0052C33.9255 41.6405 27.9568 35.6719 20.5921 35.6719ZM20.5921 59.3974C14.8529 59.3974 10.2 54.7444 10.2 49.0052C10.2 43.266 14.8529 38.6131 20.5921 38.6131C26.3313 38.6131 30.9843 43.266 30.9843 49.0052C30.9843 54.7444 26.3313 59.3974 20.5921 59.3974Z",
    fill: "url(#paint4_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5896 33.3203C11.9268 33.3203 4.90332 40.3438 4.90332 49.0066C4.90332 57.6693 11.9268 64.6929 20.5896 64.6929C29.2523 64.6929 36.2759 57.6693 36.2759 49.0066C36.2759 40.3438 29.2523 33.3203 20.5896 33.3203ZM20.5896 59.3987C14.8504 59.3987 10.1974 54.7458 10.1974 49.0066C10.1974 43.2674 14.8504 38.6144 20.5896 38.6144C26.3288 38.6144 30.9818 43.2674 30.9818 49.0066C30.9818 54.7458 26.3288 59.3987 20.5896 59.3987Z",
    fill: "url(#paint5_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0366 38.418C70.2401 38.418 63.9189 44.7391 63.9189 52.5356C63.9189 60.3321 70.2401 66.6533 78.0366 66.6533C85.8331 66.6533 92.1542 60.3321 92.1542 52.5356C92.1542 44.7391 85.8331 38.418 78.0366 38.418ZM78.0366 61.8886C72.8713 61.8886 68.6836 57.7009 68.6836 52.5356C68.6836 47.3703 72.8713 43.1827 78.0366 43.1827C83.2019 43.1827 87.3895 47.3703 87.3895 52.5356C87.3895 57.7009 83.2019 61.8886 78.0366 61.8886Z",
    fill: "url(#paint6_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0381 40.5352C71.4099 40.5352 66.0381 45.9069 66.0381 52.5352C66.0381 59.1634 71.4099 64.5352 78.0381 64.5352C84.6663 64.5352 90.0381 59.1634 90.0381 52.5352C90.0381 45.9069 84.6663 40.5352 78.0381 40.5352ZM78.0381 61.8881C72.8728 61.8881 68.6851 57.7005 68.6851 52.5352C68.6851 47.3699 72.8728 43.1822 78.0381 43.1822C83.2034 43.1822 87.391 47.3699 87.391 52.5352C87.391 57.7005 83.2034 61.8881 78.0381 61.8881Z",
    fill: "url(#paint7_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0366 38.418C70.2401 38.418 63.9189 44.7391 63.9189 52.5356C63.9189 60.3321 70.2401 66.6533 78.0366 66.6533C85.8331 66.6533 92.1542 60.3321 92.1542 52.5356C92.1542 44.7391 85.8331 38.418 78.0366 38.418ZM78.0366 61.8886C72.8713 61.8886 68.6836 57.7009 68.6836 52.5356C68.6836 47.3703 72.8713 43.1827 78.0366 43.1827C83.2019 43.1827 87.3895 47.3703 87.3895 52.5356C87.3895 57.7009 83.2019 61.8886 78.0366 61.8886Z",
    fill: "url(#paint8_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2921 53.2812C61.4978 55.0755 58.9343 55.4212 57.5662 54.0534C56.1982 52.6855 56.5439 50.1218 58.3384 48.3275C60.1327 46.5332 62.6964 46.1875 64.0643 47.5553C65.4323 48.9232 65.0866 51.4869 63.2921 53.2812Z",
    fill: "url(#paint9_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3382 48.3223C56.5439 50.1166 56.1982 52.6803 57.5661 54.0482C58.9341 55.4162 61.4977 55.0705 63.292 53.276C63.6806 52.8874 64.001 52.4627 64.251 52.0219L59.5924 47.3633C59.1516 47.6133 58.7269 47.9337 58.3382 48.3223Z",
    fill: "url(#paint10_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7666 51.3562C56.4651 53.5923 58.0335 55.1605 60.2696 54.8591C62.5056 54.5578 64.5629 52.5005 64.8643 50.2644C64.9296 49.7801 64.9068 49.3274 64.809 48.918L57.1939 49.9448C56.98 50.3962 56.8319 50.8719 56.7666 51.3562Z",
    fill: "url(#paint11_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.685 60.9357C51.4256 60.1438 51.2765 59.2854 51.2608 58.3873C51.1901 54.3061 53.8997 50.9495 57.313 50.8903C58.6095 50.8677 59.8207 51.3248 60.8283 52.1234C61.3748 52.5565 62.1514 52.5528 62.6642 52.0803C65.3207 49.6322 69.0108 49.0314 71.6377 50.8536C74.2646 52.6757 74.9948 56.3424 73.6324 59.6883C73.3695 60.3342 73.6379 61.0628 74.2352 61.423C75.3363 62.0871 76.1885 63.0612 76.6216 64.2836C77.762 67.5014 75.5673 71.2154 71.7199 72.5787C70.873 72.8787 70.0169 73.0399 69.1842 73.0742C68.5534 73.1003 68.0407 73.6175 68.076 74.2477C68.0916 74.5281 68.0807 74.8122 68.041 75.0979C67.6467 77.9365 64.5758 79.8557 61.1816 79.3844C61.1675 79.3824 61.1534 79.3805 61.1393 79.3783C58.3791 78.9791 55.593 79.8983 53.6773 81.9252L43.9189 92.2501C43.4799 92.7146 42.7297 92.2022 43.0026 91.6242L49.0109 78.9075C50.2214 76.3452 50.1579 73.3279 48.7167 70.8877C48.6691 70.8071 48.6226 70.725 48.5777 70.6418C46.9471 67.6279 47.6689 64.0791 50.1895 62.7154C50.4432 62.5781 50.7054 62.4683 50.9736 62.3848C51.5765 62.1971 51.8814 61.5357 51.685 60.9357Z",
    fill: "url(#paint12_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3126 50.8894C58.609 50.8668 59.8202 51.3239 60.8279 52.1225C61.3743 52.5557 62.151 52.5519 62.6638 52.0794C65.2971 49.6527 68.9453 49.0425 71.5677 50.8068L43.1718 92.3098C42.9777 92.1637 42.871 91.9017 43.0024 91.6233L49.0106 78.9066C50.2212 76.3443 50.1577 73.327 48.7167 70.8868C48.6691 70.8062 48.6226 70.7241 48.5777 70.6409C46.9471 67.627 47.6689 64.0782 50.1894 62.7145C50.4432 62.5772 50.7053 62.4674 50.9736 62.3839C51.5763 62.1962 51.881 61.5347 51.6845 60.9349C51.4251 60.1429 51.2761 59.2845 51.2604 58.3864C51.1894 54.3051 53.8992 50.9486 57.3126 50.8894Z",
    fill: "url(#paint13_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0407 75.0975C67.9893 75.4677 67.8915 75.8216 67.7542 76.1573L53.5185 77.1877L49.2705 63.3804C49.5436 63.1238 49.8495 62.8993 50.1893 62.7153C50.4431 62.5781 50.7052 62.4683 50.9735 62.3848C51.5762 62.1971 51.8809 61.5355 51.6844 60.9357C51.425 60.1438 51.276 59.2854 51.2603 58.3873C51.1895 54.3061 53.8991 50.9495 57.3125 50.8903C58.6089 50.8677 59.8201 51.3248 60.8278 52.1234C61.3742 52.5565 62.1509 52.5528 62.6636 52.0803C65.3201 49.6322 69.0103 49.0314 71.6372 50.8536C74.264 52.6757 74.9942 56.3424 73.6319 59.6883C73.3689 60.3342 73.6374 61.0628 74.2346 61.423C75.3358 62.0871 76.188 63.0612 76.6211 64.2836C77.7615 67.5014 75.5668 71.2154 71.7193 72.5787C70.8725 72.8787 70.0164 73.0399 69.1836 73.0742C68.5529 73.1003 68.0401 73.6175 68.0754 74.2477C68.0915 74.5277 68.0805 74.8118 68.0407 75.0975Z",
    fill: "url(#paint14_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3118 50.8903C58.6083 50.8677 59.8195 51.3248 60.8271 52.1234C61.3736 52.5565 62.1502 52.5528 62.663 52.0803C65.3195 49.6322 69.0097 49.0314 71.6365 50.8536C74.2634 52.6757 74.9936 56.3424 73.6312 59.6883C73.3683 60.3342 73.6367 61.0628 74.234 61.423C75.3351 62.0871 76.1873 63.0612 76.6204 64.2836C76.9506 65.2156 76.9997 66.1891 76.8112 67.1352L59.5408 68.3852L54.4375 51.7979C55.2902 51.2361 56.2679 50.9083 57.3118 50.8903Z",
    fill: "url(#paint15_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.562 59.5818L63.1299 51.6769C65.7391 49.5716 69.1591 49.1359 71.635 50.8532C74.0775 52.5475 74.8791 55.8363 73.8844 58.9795L65.562 59.5818Z",
    fill: "url(#paint16_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4103 50.7543C59.4103 59.1028 52.6424 65.8706 44.294 65.8706C35.9456 65.8706 29.1777 59.1028 29.1777 50.7543C29.1777 42.4059 35.9456 30.793 44.294 30.793C52.6424 30.793 59.4103 42.4057 59.4103 50.7543Z",
    fill: "url(#paint17_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1777 50.7519C29.1777 59.1003 35.9456 65.8682 44.294 65.8682C52.6424 65.8682 59.4105 59.1003 59.4105 50.7519C59.4105 47.8599 58.5979 44.5766 57.1893 41.5195H31.3989C29.9905 44.5764 29.1777 47.8599 29.1777 50.7519Z",
    fill: "url(#paint18_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1194 34.293L30.1953 56.2171C32.3859 61.8647 37.8716 65.8694 44.2932 65.8694C52.6418 65.8694 59.4094 59.1016 59.4094 50.7532C59.4094 45.2692 56.4894 38.3773 52.1194 34.293Z",
    fill: "url(#paint19_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2969 61.588C49.4698 61.588 53.6632 57.3946 53.6632 52.2217C53.6632 47.0489 49.4698 42.8555 44.2969 42.8555C39.1241 42.8555 34.9307 47.0489 34.9307 52.2217C34.9307 57.3946 39.1241 61.588 44.2969 61.588Z",
    fill: "url(#paint20_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9307 52.2175C34.9307 57.3903 39.124 61.5838 44.2969 61.5838C49.4697 61.5838 53.6632 57.3903 53.6632 52.2175C53.6632 51.0971 53.4658 50.0232 53.1052 49.0273H35.4887C35.1279 50.0232 34.9307 51.0971 34.9307 52.2175Z",
    fill: "url(#paint21_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6727 58.8414C41.3303 62.4991 47.2609 62.4993 50.9186 58.8414C54.5764 55.1836 54.5762 49.2532 50.9186 45.5956C50.1264 44.8034 49.2274 44.1834 48.2682 43.7344L35.8115 56.191C36.2605 57.1503 36.8803 58.0493 37.6727 58.8414Z",
    fill: "url(#paint22_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.273 52.8789C20.0673 54.6732 22.631 55.0189 23.9988 53.651C25.3667 52.2832 25.0212 49.7195 23.2267 47.9252C21.4322 46.1308 18.8686 45.7852 17.5008 47.153C16.1328 48.5208 16.4784 51.0846 18.273 52.8789Z",
    fill: "url(#paint23_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2311 47.9278C25.0254 49.7221 25.3711 52.2858 24.0033 53.6537C22.6352 55.0217 20.0717 54.676 18.2774 52.8815C17.8888 52.4929 17.5684 52.0682 17.3184 51.6274L21.977 46.9688C22.4178 47.2188 22.8425 47.5391 23.2311 47.9278Z",
    fill: "url(#paint24_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7987 50.9539C25.1003 53.1899 23.5319 54.7582 21.2958 54.4568C19.0597 54.1552 17.0024 52.0982 16.7011 49.8621C16.6358 49.3778 16.6585 48.925 16.7564 48.5156L24.3715 49.5425C24.5854 49.9939 24.7334 50.4695 24.7987 50.9539Z",
    fill: "url(#paint25_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8548 45.028C27.0511 46.6678 26.5209 48.3774 25.2638 49.6344L24.1381 50.7601C22.8811 52.0172 21.1713 52.5476 19.5317 52.3511C18.6985 52.2513 17.8652 52.5301 17.2719 53.1234C15.6852 54.7101 16.5956 57.4346 18.8187 57.7399C21.8411 58.1548 25.0158 57.2001 27.3411 54.8748L29.3787 52.8372C31.704 50.5119 32.6587 47.3374 32.2438 44.3148C31.9385 42.0917 29.2142 41.1813 27.6273 42.768C27.0336 43.3615 26.755 44.1948 26.8548 45.028Z",
    fill: "url(#paint26_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8536 45.0266C27.0501 46.6664 26.5197 48.376 25.2626 49.6331L24.1369 50.7588C22.8799 52.0158 21.1701 52.5462 19.5305 52.3497C18.6973 52.2499 17.864 52.5288 17.2707 53.1221C16.5526 53.8401 16.3475 54.7905 16.5422 55.6448C16.6146 55.6605 16.6881 55.6743 16.7636 55.6846C19.7859 56.0995 22.9607 55.1448 25.2859 52.8195L27.3236 50.7819C29.6489 48.4566 30.6036 45.2821 30.1887 42.2597C30.1783 42.1843 30.1648 42.1107 30.1489 42.0384C29.2946 41.8435 28.3442 42.049 27.6261 42.7668C27.0326 43.3599 26.7538 44.1933 26.8536 45.0266Z",
    fill: "url(#paint27_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.619 60.7605C41.0225 60.636 40.6025 60.1123 40.6035 59.5031C40.6035 59.4994 40.6035 59.4954 40.6035 59.4917C40.6035 54.8925 36.8751 51.1641 32.2759 51.1641C28.3133 51.1641 24.999 53.9323 24.157 57.6403C24.0416 58.1494 23.6163 58.5248 23.101 58.6084C19.1127 59.255 16.0741 62.7341 16.1167 66.9148C16.1635 71.515 20.0018 75.2397 24.6014 75.1543C25.5431 75.1368 26.4465 74.9629 27.2867 74.6576C29.9231 73.6997 32.8535 74.1419 35.1545 75.7464C36.5229 76.7007 38.1916 77.2543 39.9908 77.2372C44.3884 77.1952 48.0331 73.6837 48.2286 69.2903C48.4147 65.1099 45.5169 61.5737 41.619 60.7605Z",
    fill: "url(#paint28_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6184 60.7594C41.022 60.6349 40.602 60.1111 40.603 59.5019C40.603 59.4982 40.603 59.4943 40.603 59.4905C40.603 55.517 37.8198 52.1941 34.0967 51.3633V75.1121C34.4608 75.2976 34.8143 75.5084 35.1539 75.7452C36.5224 76.6996 38.191 77.2531 39.9902 77.236C44.3879 77.1941 48.0326 73.6825 48.2281 69.2892C48.4141 65.1088 45.5163 61.5725 41.6184 60.7594Z",
    fill: "url(#paint29_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1166 66.9104C16.1635 71.5105 20.0017 75.2353 24.6013 75.1498C25.5429 75.1323 26.4464 74.9584 27.2866 74.6531C29.9231 73.6953 32.8535 74.1374 35.1545 75.7419C36.5229 76.6962 38.1915 77.2498 39.9907 77.2327C44.3884 77.1907 48.0331 73.6792 48.2286 69.2858C48.2825 68.0723 48.0762 66.9135 47.6615 65.8594H16.1719C16.1323 66.2039 16.1131 66.5545 16.1166 66.9104Z",
    fill: "url(#paint30_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7748 60.1494C40.494 64.4219 37.0556 67.8323 32.7713 68.0666C32.8171 67.7084 32.8407 67.3427 32.8407 66.9719C32.8407 62.2805 29.0371 58.477 24.3458 58.477C24.0185 58.477 23.6966 58.4954 23.3789 58.5317C23.7638 58.3796 24.0622 58.0539 24.156 57.6401C24.9981 53.9327 28.3124 51.1641 32.2748 51.1641C36.8738 51.1641 40.6026 54.8921 40.6026 59.4919V59.5031C40.6019 59.7372 40.6648 59.958 40.7748 60.1494Z",
    fill: "url(#paint31_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1955 72.9246C45.5892 72.7975 43.9249 72.7305 42.2194 72.7305C37.2784 72.7305 32.6828 73.2912 28.8467 74.2536C31.0349 73.9128 33.2975 74.4505 35.1514 75.7432C36.5198 76.6975 38.1884 77.2511 39.9877 77.234C43.0692 77.2048 45.7812 75.4713 47.1955 72.9246Z",
    fill: "url(#paint32_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6186 60.7547C41.2516 60.6786 40.9516 60.4504 40.7751 60.1445C40.5239 63.9657 37.7457 67.0977 34.0967 67.883V75.1081C34.4608 75.2936 34.8147 75.5039 35.1537 75.7412C36.5226 76.6955 38.1912 77.2488 39.9898 77.2318C44.3879 77.1896 48.0326 73.6781 48.2282 69.2851C48.4145 65.1039 45.5159 61.5679 41.6186 60.7547Z",
    fill: "url(#paint33_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3663 66.3654C84.5391 66.3654 88.7326 62.1719 88.7326 56.9991C88.7326 51.8262 84.5391 47.6328 79.3663 47.6328C74.1934 47.6328 70 51.8262 70 56.9991C70 62.1719 74.1934 66.3654 79.3663 66.3654Z",
    fill: "url(#paint34_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0865 51.3367L73.7061 60.717C73.2336 61.1896 72.4397 61.0465 72.1516 60.4433C70.7326 57.472 71.2532 53.8057 73.7144 51.3447C76.1742 48.8849 79.8414 48.3633 82.8128 49.782C83.4159 50.0702 83.5593 50.8641 83.0865 51.3367Z",
    fill: "url(#paint35_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0221 62.6536C82.5611 65.1146 78.8949 65.6352 75.9235 64.2164C75.3204 63.9283 75.177 63.1344 75.6498 62.6618L85.0302 53.2815C85.5027 52.8089 86.2968 52.9522 86.5847 53.5554C88.0033 56.5266 87.4819 60.1938 85.0221 62.6536Z",
    fill: "url(#paint36_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8797 53.2558C77.5689 53.945 77.8481 54.7831 77.5036 55.1276C77.1591 55.4721 76.3211 55.1929 75.6318 54.5037C74.9426 53.8145 74.6634 52.9764 75.0079 52.6319C75.3524 52.2874 76.1905 52.5668 76.8797 53.2558Z",
    fill: "url(#paint37_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3746 56.3805C75.2789 56.744 75.8646 57.4054 75.6826 57.8575C75.5008 58.3097 74.6204 58.3814 73.7161 58.0177C72.8118 57.6542 72.2263 56.9928 72.4081 56.5407C72.5898 56.0885 73.4704 56.0167 74.3746 56.3805Z",
    fill: "url(#paint38_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7641 51.9878C79.1276 52.8921 79.789 53.4778 80.2412 53.2959C80.6933 53.1141 80.7651 52.2337 80.4014 51.3294C80.0378 50.4251 79.3765 49.8396 78.9243 50.0214C78.4723 50.2031 78.4006 51.0835 78.7641 51.9878Z",
    fill: "url(#paint39_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1063 59.4902C82.417 58.801 81.579 58.5218 81.2345 58.8663C80.89 59.2108 81.1692 60.0489 81.8584 60.7381C82.5476 61.4273 83.3857 61.7065 83.7302 61.362C84.0747 61.0175 83.7953 60.1795 83.1063 59.4902Z",
    fill: "url(#paint40_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9806 62.0052C79.6171 61.1009 78.9557 60.5152 78.5035 60.6972C78.0514 60.879 77.9796 61.7594 78.3434 62.6637C78.7069 63.568 79.3682 64.1535 79.8204 63.9717C80.2726 63.7899 80.3443 62.9094 79.9806 62.0052Z",
    fill: "url(#paint41_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3715 57.6193C83.4671 57.2557 82.8815 56.5944 83.0634 56.1422C83.2452 55.6901 84.1256 55.6183 85.0299 55.982C85.9342 56.3456 86.5197 57.0069 86.3379 57.4591C86.1562 57.911 85.2758 57.9828 84.3715 57.6193Z",
    fill: "url(#paint42_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7433 50.3729C69.0857 54.0305 69.0855 59.9611 72.7433 63.6188C76.4012 67.2766 82.3315 67.2764 85.9892 63.6188C86.7814 62.8266 87.4013 61.9276 87.8504 60.9684L75.3937 48.5117C74.4345 48.9607 73.5355 49.5807 72.7433 50.3729Z",
    fill: "url(#paint43_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 57.0027C70 62.1754 74.1933 66.369 79.3663 66.369C84.5392 66.369 88.7326 62.1754 88.7326 57.0027C88.7326 55.8823 88.5351 54.8084 88.1745 53.8125H70.558C70.1975 54.8084 70 55.8823 70 57.0027Z",
    fill: "url(#paint44_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9412 56.2578C54.2784 56.2578 47.2549 63.2813 47.2549 71.9441C47.2549 80.6068 54.2784 87.6304 62.9412 87.6304C71.6039 87.6304 78.6274 80.6068 78.6274 71.9441C78.6274 63.2813 71.6039 56.2578 62.9412 56.2578ZM62.9412 82.3362C57.2019 82.3362 52.549 77.6833 52.549 71.9441C52.549 66.2049 57.2019 61.5519 62.9412 61.5519C68.6804 61.5519 73.3333 66.2049 73.3333 71.9441C73.3333 77.6833 68.6804 82.3362 62.9412 82.3362Z",
    fill: "url(#paint45_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9437 58.6133C55.579 58.6133 49.6104 64.5819 49.6104 71.9466C49.6104 79.3113 55.579 85.2799 62.9437 85.2799C70.3084 85.2799 76.277 79.3113 76.277 71.9466C76.277 64.5819 70.3084 58.6133 62.9437 58.6133ZM62.9437 82.3388C57.2045 82.3388 52.5515 77.6858 52.5515 71.9466C52.5515 66.2074 57.2045 61.5545 62.9437 61.5545C68.6829 61.5545 73.3358 66.2074 73.3358 71.9466C73.3358 77.6858 68.6829 82.3388 62.9437 82.3388Z",
    fill: "url(#paint46_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.977 70.539C34.7713 72.3334 37.335 72.679 38.7029 71.3112C40.0707 69.9434 39.7252 67.3796 37.9307 65.5853C36.1364 63.791 33.5727 63.4453 32.2048 64.8132C30.837 66.181 31.1825 68.7447 32.977 70.539Z",
    fill: "url(#paint47_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9303 65.5879C39.7246 67.3822 40.0703 69.9458 38.7025 71.3138C37.3344 72.6819 34.7709 72.3362 32.9766 70.5417C32.588 70.153 32.2676 69.7283 32.0176 69.2875L36.6762 64.6289C37.117 64.8789 37.5417 65.1993 37.9303 65.5879Z",
    fill: "url(#paint48_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5028 68.6062C39.8044 70.8423 38.2362 72.4105 35.9999 72.1091C33.7638 71.8076 31.7065 69.7505 31.4052 67.5144C31.3399 67.0301 31.3626 66.5774 31.4605 66.168L39.0756 67.1948C39.2895 67.6462 39.4375 68.1219 39.5028 68.6062Z",
    fill: "url(#paint49_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0167 75.8693C52.1895 75.8693 56.3829 71.6758 56.3829 66.503C56.3829 61.3301 52.1895 57.1367 47.0167 57.1367C41.8438 57.1367 37.6504 61.3301 37.6504 66.503C37.6504 71.6758 41.8438 75.8693 47.0167 75.8693Z",
    fill: "url(#paint50_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.644 59.8726V73.1385C45.644 73.8069 44.9813 74.2669 44.3511 74.0442C41.2468 72.9465 39.0225 69.9859 39.0225 66.5055C39.0225 63.0269 41.2468 60.065 44.3511 58.9669C44.9813 58.7442 45.644 59.2042 45.644 59.8726Z",
    fill: "url(#paint51_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0132 66.5055C55.0132 69.9859 52.7889 72.9465 49.6845 74.0442C49.0543 74.2669 48.3916 73.8069 48.3916 73.1385V59.8726C48.3916 59.2042 49.0543 58.7442 49.6845 58.9669C52.7889 60.065 55.0132 63.0269 55.0132 66.5055Z",
    fill: "url(#paint52_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6085 67.3897C43.5831 67.3897 44.3732 66.9947 44.3732 66.5074C44.3732 66.02 43.5831 65.625 42.6085 65.625C41.6338 65.625 40.8438 66.02 40.8438 66.5074C40.8438 66.9947 41.6338 67.3897 42.6085 67.3897Z",
    fill: "url(#paint53_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0396 69.6106C43.9361 69.2282 44.8178 69.2818 45.009 69.73C45.2002 70.1783 44.6284 70.8516 43.7318 71.2339C42.8351 71.6163 41.9535 71.5628 41.7624 71.1145C41.5714 70.6661 42.1431 69.993 43.0396 69.6106Z",
    fill: "url(#paint54_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0396 63.4058C43.9361 63.7882 44.8178 63.7346 45.009 63.2864C45.2002 62.8382 44.6284 62.1648 43.7318 61.7825C42.8351 61.4001 41.9535 61.4537 41.7624 61.9019C41.5714 62.3503 42.1431 63.0237 43.0396 63.4058Z",
    fill: "url(#paint55_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.42 67.3897C52.3946 67.3897 53.1847 66.9947 53.1847 66.5074C53.1847 66.02 52.3946 65.625 51.42 65.625C50.4454 65.625 49.6553 66.02 49.6553 66.5074C49.6553 66.9947 50.4454 67.3897 51.42 67.3897Z",
    fill: "url(#paint56_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9789 69.6106C50.0824 69.2282 49.2007 69.2818 49.0095 69.73C48.8183 70.1783 49.3901 70.8516 50.2868 71.2339C51.1832 71.6163 52.065 71.5628 52.2562 71.1145C52.4471 70.6661 51.8754 69.993 50.9789 69.6106Z",
    fill: "url(#paint57_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9789 63.4058C50.0824 63.7882 49.2007 63.7346 49.0095 63.2864C48.8183 62.8382 49.3901 62.1648 50.2868 61.7825C51.1832 61.4001 52.065 61.4537 52.2562 61.9019C52.4471 62.3503 51.8754 63.0237 50.9789 63.4058Z",
    fill: "url(#paint58_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6504 66.5066C37.6504 71.6794 41.8437 75.8729 47.0167 75.8729C52.1894 75.8729 56.3829 71.6794 56.3829 66.5066C56.3829 65.3862 56.1855 64.3123 55.8249 63.3164H38.2084C37.8478 64.3123 37.6504 65.3864 37.6504 66.5066Z",
    fill: "url(#paint59_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3924 73.1227C44.0501 76.7803 49.9807 76.7805 53.6383 73.1227C57.2962 69.4648 57.296 63.5344 53.6383 59.8768C52.8462 59.0846 51.9471 58.4646 50.9879 58.0156L38.5312 70.4723C38.9803 71.4315 39.6003 72.3305 40.3924 73.1227Z",
    fill: "url(#paint60_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6386 74.357C47.4421 72.7172 47.9725 71.0076 49.2295 69.7505L50.3552 68.6248C51.6123 67.3678 53.3221 66.8374 54.9617 67.0339C55.7948 67.1337 56.6282 66.8548 57.2215 66.2615C58.8082 64.6748 57.8978 61.9503 55.6746 61.645C52.6523 61.2301 49.4776 62.1848 47.1523 64.5101L45.1146 66.5478C42.7893 68.8731 41.8346 72.0476 42.2495 75.0701C42.5548 77.2933 45.2791 78.2037 46.866 76.617C47.4595 76.0235 47.7384 75.1901 47.6386 74.357Z",
    fill: "url(#paint61_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6413 74.3617C47.4448 72.7219 47.9752 71.0123 49.2323 69.7552L50.3579 68.6295C51.615 67.3725 53.3248 66.8421 54.9644 67.0385C55.7976 67.1383 56.6309 66.8595 57.2242 66.2662C57.9423 65.5481 58.1474 64.5978 57.9526 63.7434C57.8803 63.7278 57.8068 63.714 57.7313 63.7036C54.7089 63.2887 51.5342 64.2434 49.2089 66.5687L47.1713 68.6064C44.846 70.9317 43.8913 74.1062 44.3062 77.1285C44.3166 77.204 44.3301 77.2776 44.346 77.3499C45.2003 77.5448 46.1507 77.3393 46.8687 76.6215C47.4623 76.0281 47.7411 75.1948 47.6413 74.3617Z",
    fill: "url(#paint62_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0826 58.0341C83.7224 57.8378 85.432 58.368 86.6891 59.625L87.8148 60.7507C89.0719 62.0078 89.6022 63.7176 89.4058 65.3572C89.306 66.1903 89.5848 67.0237 90.1781 67.617C91.7648 69.2037 94.4893 68.2933 94.7946 66.0701C95.2095 63.0478 94.2548 59.8731 91.9295 57.5478L89.8919 55.5101C87.5666 53.1848 84.392 52.2301 81.3695 52.645C79.1464 52.9503 78.236 55.6747 79.8226 57.2615C80.4162 57.8552 81.2495 58.1339 82.0826 58.0341Z",
    fill: "url(#paint63_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0812 58.0309C83.721 57.8345 85.4306 58.3648 86.6877 59.6219L87.8134 60.7476C89.0704 62.0047 89.6008 63.7145 89.4044 65.3541C89.3045 66.1872 89.5834 67.0205 90.1767 67.6139C90.8947 68.3319 91.8451 68.537 92.6994 68.3423C92.7151 68.2699 92.7289 68.1964 92.7393 68.1209C93.1542 65.0986 92.1994 61.9239 89.8742 59.5986L87.8365 57.5609C85.5112 55.2356 82.3367 54.2809 79.3143 54.6958C79.2389 54.7062 79.1653 54.7197 79.093 54.7356C78.8983 55.5899 79.1036 56.5403 79.8214 57.2584C80.4145 57.8519 81.2479 58.1307 82.0812 58.0309Z",
    fill: "url(#paint64_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3964 64.0501C89.9974 63.9667 89.7162 63.6164 89.7168 63.2087C89.7168 63.2062 89.7168 63.2036 89.7168 63.2011C89.7168 60.1236 87.2221 57.6289 84.1447 57.6289C81.4933 57.6289 79.2757 59.4813 78.7123 61.9622C78.6351 62.3028 78.3506 62.554 78.0057 62.6099C75.337 63.0424 73.3039 65.3705 73.3323 68.1677C73.3637 71.2458 75.9319 73.7379 79.0096 73.6809C79.6396 73.6691 80.2441 73.5528 80.8064 73.3485C82.5706 72.7075 84.5313 73.0034 86.071 74.0771C86.9866 74.7158 88.1031 75.0862 89.307 75.0746C92.2496 75.0466 94.6882 72.6969 94.819 69.7573C94.9435 66.9603 93.0045 64.5942 90.3964 64.0501Z",
    fill: "url(#paint65_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3982 64.0566C89.9992 63.9733 89.718 63.6229 89.7186 63.2152C89.7186 63.2127 89.7186 63.2101 89.7186 63.2076C89.7186 60.5489 87.8564 58.3254 85.3652 57.7695V73.6601C85.6088 73.7842 85.8454 73.9252 86.0727 74.0836C86.9884 74.7223 88.1048 75.0927 89.3086 75.0811C92.2511 75.0531 94.6897 72.7035 94.8205 69.7638C94.9452 66.9668 93.0062 64.6007 90.3982 64.0566Z",
    fill: "url(#paint66_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3323 68.1719C73.3637 71.2499 75.932 73.7421 79.0096 73.685C79.6396 73.6733 80.2441 73.557 80.8065 73.3527C82.5706 72.7117 84.5314 73.0076 86.071 74.0813C86.9867 74.7199 88.1031 75.0903 89.3069 75.0788C92.2494 75.0507 94.688 72.7011 94.8188 69.7615C94.8549 68.9495 94.7169 68.174 94.4394 67.4688H73.3692C73.3427 67.6993 73.3298 67.9338 73.3323 68.1719Z",
    fill: "url(#paint67_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8312 63.6411C89.6434 66.4999 87.3426 68.7818 84.4759 68.9385C84.5065 68.6987 84.5224 68.4542 84.5224 68.206C84.5224 65.0669 81.9775 62.522 78.8385 62.522C78.6194 62.522 78.404 62.5344 78.1914 62.5587C78.4489 62.4569 78.6487 62.2389 78.7114 61.962C79.2749 59.4815 81.4926 57.6289 84.1438 57.6289C87.221 57.6289 89.7161 60.1234 89.7161 63.2013V63.2087C89.7157 63.3652 89.7577 63.513 89.8312 63.6411Z",
    fill: "url(#paint68_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1317 72.1923C93.0568 72.1074 91.9435 72.0625 90.8023 72.0625C87.4963 72.0625 84.4214 72.4378 81.8545 73.0817C83.3186 72.8537 84.8325 73.2135 86.0729 74.0784C86.9886 74.717 88.1051 75.0874 89.3088 75.0758C91.371 75.0562 93.1855 73.8964 94.1317 72.1923Z",
    fill: "url(#paint69_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3984 64.0489C90.1527 63.9979 89.9521 63.8451 89.8339 63.6406C89.6658 66.1975 87.807 68.2932 85.3652 68.8185V73.6528C85.609 73.7769 85.8456 73.9177 86.0725 74.0763C86.9884 74.7149 88.1048 75.0851 89.3084 75.0738C92.2511 75.0455 94.6899 72.6959 94.8209 69.7565C94.9456 66.9591 93.006 64.593 90.3984 64.0489Z",
    fill: "url(#paint70_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5626 70.9258C74.7683 72.7201 72.2046 73.0658 70.8367 71.6979C69.4687 70.3299 69.8144 67.7664 71.6089 65.972C73.4032 64.1777 75.9669 63.832 77.3348 65.1999C78.7026 66.5677 78.3569 69.1314 76.5626 70.9258Z",
    fill: "url(#paint71_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6088 65.9746C69.8144 67.769 69.4688 70.3325 70.8366 71.7005C72.2044 73.0686 74.7682 72.7229 76.5625 70.9284C76.9511 70.5397 77.2715 70.115 77.5215 69.6743L72.8629 65.0156C72.4221 65.2656 71.9974 65.586 71.6088 65.9746Z",
    fill: "url(#paint72_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0371 69.0007C69.7356 71.2368 71.304 72.805 73.5401 72.5037C75.7761 72.2021 77.8334 70.1451 78.1348 67.909C78.2001 67.4247 78.1773 66.9719 78.0795 66.5625L70.4644 67.5894C70.2505 68.0407 70.1024 68.5164 70.0371 69.0007Z",
    fill: "url(#paint73_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2381 60.9357C25.4975 60.1438 25.6466 59.2854 25.6622 58.3873C25.733 54.3061 23.0234 50.9495 19.6101 50.8903C18.3136 50.8677 17.1024 51.3248 16.0948 52.1234C15.5483 52.5565 14.7717 52.5528 14.2589 52.0803C11.6024 49.6322 7.91224 49.0314 5.28538 50.8536C2.65852 52.6757 1.92832 56.3424 3.29068 59.6883C3.55362 60.3342 3.28519 61.0628 2.68793 61.423C1.58675 62.0871 0.734597 63.0612 0.30146 64.2836C-0.838932 67.5014 1.35577 71.2154 5.20322 72.5787C6.05009 72.8787 6.90617 73.0399 7.73891 73.0742C8.3697 73.1003 8.88244 73.6175 8.84715 74.2477C8.83146 74.5281 8.84244 74.8122 8.88205 75.0979C9.27636 77.9365 12.3473 79.8557 15.7415 79.3844C15.7556 79.3824 15.7697 79.3805 15.7838 79.3783C18.544 78.9791 21.3301 79.8983 23.2458 81.9252L33.0042 92.2501C33.4432 92.7146 34.1934 92.2022 33.9205 91.6242L27.9122 78.9075C26.7017 76.3452 26.7652 73.3279 28.2064 70.8877C28.254 70.8071 28.3005 70.725 28.3454 70.6418C29.976 67.6279 29.2542 64.0791 26.7336 62.7154C26.4799 62.5781 26.2177 62.4683 25.9495 62.3848C25.3464 62.1971 25.0417 61.5357 25.2381 60.9357Z",
    fill: "url(#paint74_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6086 50.8894C18.3121 50.8668 17.101 51.3239 16.0933 52.1225C15.5468 52.5557 14.7702 52.5519 14.2574 52.0794C11.6241 49.6527 7.97587 49.0425 5.35352 50.8068L33.7494 92.3098C33.9435 92.1637 34.0502 91.9017 33.9188 91.6233L27.9106 78.9066C26.7 76.3443 26.7635 73.327 28.2045 70.8868C28.2521 70.8062 28.2986 70.7241 28.3435 70.6409C29.9741 67.627 29.2523 64.0782 26.7318 62.7145C26.478 62.5772 26.2159 62.4674 25.9476 62.3839C25.3449 62.1962 25.0402 61.5347 25.2367 60.9349C25.4961 60.1429 25.6451 59.2845 25.6608 58.3864C25.7316 54.3051 23.0219 50.9486 19.6086 50.8894Z",
    fill: "url(#paint75_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88185 75.0975C8.93323 75.4677 9.03107 75.8216 9.16832 76.1573L23.404 77.1877L27.6521 63.3804C27.3789 63.1238 27.073 62.8993 26.7332 62.7153C26.4795 62.5781 26.2173 62.4683 25.9491 62.3848C25.3464 62.1971 25.0417 61.5355 25.2381 60.9357C25.4975 60.1438 25.6466 59.2854 25.6622 58.3873C25.733 54.3061 23.0234 50.9495 19.6101 50.8903C18.3136 50.8677 17.1024 51.3248 16.0948 52.1234C15.5483 52.5565 14.7717 52.5528 14.2589 52.0803C11.6024 49.6322 7.91225 49.0314 5.28538 50.8536C2.65852 52.6757 1.92832 56.3424 3.29068 59.6883C3.55362 60.3342 3.28519 61.0628 2.68793 61.423C1.58675 62.0871 0.734597 63.0612 0.30146 64.2836C-0.838932 67.5014 1.35577 71.2154 5.20323 72.5787C6.05009 72.8787 6.90617 73.0399 7.73891 73.0742C8.3697 73.1003 8.88244 73.6175 8.84715 74.2477C8.83127 74.5277 8.84225 74.8118 8.88185 75.0975Z",
    fill: "url(#paint76_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.609 50.8903C18.3125 50.8677 17.1013 51.3248 16.0937 52.1234C15.5472 52.5565 14.7705 52.5528 14.2578 52.0803C11.6013 49.6322 7.91113 49.0314 5.28426 50.8536C2.6574 52.6757 1.9272 56.3424 3.28956 59.6883C3.5525 60.3342 3.28407 61.0628 2.68681 61.423C1.58564 62.0871 0.733478 63.0612 0.300341 64.2836C-0.029855 65.2156 -0.0788746 66.1891 0.109557 67.1352L17.3799 68.3852L22.4833 51.7979C21.6303 51.2361 20.6529 50.9083 19.609 50.8903Z",
    fill: "url(#paint77_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.357 59.5818L13.7892 51.6769C11.1799 49.5716 7.75994 49.1359 5.28405 50.8532C2.84151 52.5475 2.03994 55.8363 3.03464 58.9795L11.357 59.5818Z",
    fill: "url(#paint78_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2955 68.2255C12.9353 68.0292 14.6449 68.5594 15.902 69.8165L17.0277 70.9421C18.2847 72.1992 18.8151 73.909 18.6187 75.5486C18.5189 76.3817 18.7977 77.2151 19.391 77.8084C20.9777 79.3951 23.7022 78.4847 24.0075 76.2616C24.4224 73.2392 23.4677 70.0645 21.1424 67.7392L19.1047 65.7015C16.7795 63.3763 13.6049 62.4215 10.5824 62.8365C8.35926 63.1417 7.44886 65.8661 9.03553 67.4529C9.62906 68.0466 10.4624 68.3253 11.2955 68.2255Z",
    fill: "url(#paint79_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2942 68.2301C12.934 68.0337 14.6436 68.5641 15.9007 69.8211L17.0263 70.9468C18.2834 72.2039 18.8138 73.9137 18.6173 75.5533C18.5175 76.3864 18.7963 77.2197 19.3897 77.8131C20.1077 78.5311 21.0581 78.7362 21.9124 78.5415C21.9281 78.4692 21.9418 78.3956 21.9522 78.3201C22.3671 75.2978 21.4124 72.1231 19.0871 69.7978L17.0495 67.7601C14.7242 65.4348 11.5497 64.4801 8.52732 64.895C8.45183 64.9054 8.3783 64.919 8.30595 64.9348C8.11104 65.7892 8.31653 66.7396 9.03438 67.4576C9.62771 68.0513 10.461 68.3299 11.2942 68.2301Z",
    fill: "url(#paint80_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5202 93.7641H21.4798C11.8219 93.7641 3.26273 87.5441 0.280381 78.3582C-0.905109 74.7066 1.81685 70.9609 5.65607 70.9609H94.3439C98.1831 70.9609 100.905 74.7066 99.7196 78.3582C96.7371 87.5441 88.178 93.7641 78.5202 93.7641Z",
    fill: "url(#paint81_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0283203 77.1602C0.0679282 77.5592 0.14832 77.9619 0.278909 78.3639V78.3641C3.26126 87.55 11.8205 93.7698 21.4783 93.7698H78.5187C88.1766 93.7698 96.7358 87.5498 99.7181 78.3639C99.8485 77.9621 99.9291 77.5592 99.9687 77.1602H0.0283203Z",
    fill: "url(#paint82_linear_331_15535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3413 70.9609H46.9072V93.7641H78.5176C88.1755 93.7641 96.7347 87.5441 99.717 78.3582C100.903 74.7066 98.1806 70.9609 94.3413 70.9609Z",
    fill: "url(#paint83_linear_331_15535)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_331_15535",
    x1: 67.6817,
    y1: 28.0865,
    x2: 75.7956,
    y2: 36.2004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4573A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_331_15535",
    x1: 59.366,
    y1: 53.5037,
    x2: 50.6137,
    y2: 31.7245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89580"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4573A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_331_15535",
    x1: 57.6557,
    y1: 50.0429,
    x2: 60.1999,
    y2: 58.2864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4573A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2429,
    stopColor: "#BF5539",
    stopOpacity: 0.243
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5221,
    stopColor: "#B15036",
    stopOpacity: 0.522
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818,
    stopColor: "#9A4631",
    stopOpacity: 0.818
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883F2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_331_15535",
    x1: 13.8576,
    y1: 42.2746,
    x2: 33.0712,
    y2: 61.4884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDFCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_331_15535",
    x1: 29.0888,
    y1: 57.5019,
    x2: 13.5588,
    y2: 41.9721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDFCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_331_15535",
    x1: 16.9978,
    y1: 45.9176,
    x2: 23.5337,
    y2: 51.5385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA78F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9385,
    stopColor: "#FFA78F",
    stopOpacity: 0.939
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA78F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_331_15535",
    x1: 71.978,
    y1: 46.477,
    x2: 89.2701,
    y2: 63.7691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDFCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_331_15535",
    x1: 85.6852,
    y1: 60.1822,
    x2: 71.7081,
    y2: 46.2052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDFCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_331_15535",
    x1: 80.1599,
    y1: 44.467,
    x2: 78.1991,
    y2: 51.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA78F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9385,
    stopColor: "#FFA78F",
    stopOpacity: 0.939
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA78F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_331_15535",
    x1: 60.8114,
    y1: 48.5568,
    x2: 60.8113,
    y2: 53.8087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_331_15535",
    x1: 60.6144,
    y1: 50.9806,
    x2: 57.5724,
    y2: 54.0227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3174,
    stopColor: "#3B373B",
    stopOpacity: 0.317
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8224,
    stopColor: "#242324",
    stopOpacity: 0.822
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_331_15535",
    x1: 60.8374,
    y1: 50.9082,
    x2: 61.4256,
    y2: 53.5227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3174,
    stopColor: "#3B373B",
    stopOpacity: 0.317
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8224,
    stopColor: "#242324",
    stopOpacity: 0.822
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_331_15535",
    x1: 61.0732,
    y1: 46.2871,
    x2: 60.1581,
    y2: 72.5616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2E62E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1231,
    stopColor: "#97DE30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3395,
    stopColor: "#79CB36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6234,
    stopColor: "#4AAB3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9609,
    stopColor: "#09804C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#017B4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_331_15535",
    x1: 54.0547,
    y1: 63.7415,
    x2: 60.264,
    y2: 78.5782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    stopColor: "#046842",
    stopOpacity: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#0E6546",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#1D614C",
    stopOpacity: 0.748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#335C54",
    stopOpacity: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_331_15535",
    x1: 66.4178,
    y1: 56.2783,
    x2: 55.8295,
    y2: 81.5724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    stopColor: "#046842",
    stopOpacity: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#0E6546",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#1D614C",
    stopOpacity: 0.748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#335C54",
    stopOpacity: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_331_15535",
    x1: 69.1351,
    y1: 51.963,
    x2: 59.1351,
    y2: 73.3356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    stopColor: "#046842",
    stopOpacity: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#0E6546",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#1D614C",
    stopOpacity: 0.748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#335C54",
    stopOpacity: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_331_15535",
    x1: 70.9669,
    y1: 49.9944,
    x2: 64.7579,
    y2: 63.4585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    stopColor: "#046842",
    stopOpacity: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#0E6546",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#1D614C",
    stopOpacity: 0.748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#335C54",
    stopOpacity: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_331_15535",
    x1: 36.1101,
    y1: 41.1087,
    x2: 62.2554,
    y2: 67.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDFCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_331_15535",
    x1: 44.2942,
    y1: 50.3499,
    x2: 44.2942,
    y2: 64.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA78F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9385,
    stopColor: "#FFA78F",
    stopOpacity: 0.939
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA78F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_331_15535",
    x1: 44.0747,
    y1: 49.0726,
    x2: 54.5685,
    y2: 59.5663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA78F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9385,
    stopColor: "#FFA78F",
    stopOpacity: 0.939
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA78F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_331_15535",
    x1: 40.6779,
    y1: 48.6027,
    x2: 49.1924,
    y2: 57.1174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_331_15535",
    x1: 44.2969,
    y1: 52.3362,
    x2: 44.2969,
    y2: 63.3542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1766,
    stopColor: "#FDA116",
    stopOpacity: 0.177
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3939,
    stopColor: "#FA921D",
    stopOpacity: 0.394
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6325,
    stopColor: "#F4792A",
    stopOpacity: 0.633
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8846,
    stopColor: "#ED573B",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_331_15535",
    x1: 44.4501,
    y1: 52.2646,
    x2: 52.6498,
    y2: 60.4642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1766,
    stopColor: "#FDA116",
    stopOpacity: 0.177
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3939,
    stopColor: "#FA921D",
    stopOpacity: 0.394
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6325,
    stopColor: "#F4792A",
    stopOpacity: 0.633
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8846,
    stopColor: "#ED573B",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_331_15535",
    x1: 20.75,
    y1: 48.1546,
    x2: 20.75,
    y2: 53.4063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_331_15535",
    x1: 20.9513,
    y1: 50.5862,
    x2: 23.9932,
    y2: 53.6281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3174,
    stopColor: "#3B373B",
    stopOpacity: 0.317
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8224,
    stopColor: "#242324",
    stopOpacity: 0.822
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_331_15535",
    x1: 20.7279,
    y1: 50.5058,
    x2: 20.1397,
    y2: 53.1203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3174,
    stopColor: "#3B373B",
    stopOpacity: 0.317
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8224,
    stopColor: "#242324",
    stopOpacity: 0.822
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_331_15535",
    x1: 23.817,
    y1: 49.3134,
    x2: 28.6101,
    y2: 54.1066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_331_15535",
    x1: 23.4819,
    y1: 48.9886,
    x2: 28.2597,
    y2: 53.7664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C41926",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#C01A27",
    stopOpacity: 0.176
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3761,
    stopColor: "#B21E29",
    stopOpacity: 0.376
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5886,
    stopColor: "#9B242C",
    stopOpacity: 0.589
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8079,
    stopColor: "#7B2D31",
    stopOpacity: 0.808
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593636"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_331_15535",
    x1: 28.7718,
    y1: 60.4874,
    x2: 37.2665,
    y2: 78.8805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2E62E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1231,
    stopColor: "#97DE30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3395,
    stopColor: "#79CB36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6234,
    stopColor: "#4AAB3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9609,
    stopColor: "#09804C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#017B4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_331_15535",
    x1: 41.1043,
    y1: 65.9541,
    x2: 49.9684,
    y2: 69.0566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    stopColor: "#046842",
    stopOpacity: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#0E6546",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#1D614C",
    stopOpacity: 0.748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#335C54",
    stopOpacity: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_331_15535",
    x1: 31.7978,
    y1: 71.7517,
    x2: 31.2068,
    y2: 77.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    stopColor: "#046842",
    stopOpacity: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#0E6546",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#1D614C",
    stopOpacity: 0.748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#335C54",
    stopOpacity: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_331_15535",
    x1: 30.3693,
    y1: 59.9997,
    x2: 22.5885,
    y2: 61.5264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    stopColor: "#046842",
    stopOpacity: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#0E6546",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#1D614C",
    stopOpacity: 0.748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#335C54",
    stopOpacity: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_331_15535",
    x1: 36.3359,
    y1: 73.1328,
    x2: 28.3088,
    y2: 70.7689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    stopColor: "#046842",
    stopOpacity: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#0E6546",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#1D614C",
    stopOpacity: 0.748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#335C54",
    stopOpacity: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_331_15535",
    x1: 41.1669,
    y1: 64.3069,
    x2: 41.1669,
    y2: 59.1834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    stopColor: "#046842",
    stopOpacity: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#0E6546",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#1D614C",
    stopOpacity: 0.748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#335C54",
    stopOpacity: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_331_15535",
    x1: 79.3544,
    y1: 51.8708,
    x2: 79.3542,
    y2: 63.9104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_331_15535",
    x1: 74.7237,
    y1: 43.3572,
    x2: 78.8825,
    y2: 60.4776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C41926",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#C01A27",
    stopOpacity: 0.176
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3761,
    stopColor: "#B21E29",
    stopOpacity: 0.376
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5886,
    stopColor: "#9B242C",
    stopOpacity: 0.589
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8079,
    stopColor: "#7B2D31",
    stopOpacity: 0.808
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593636"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_331_15535",
    x1: 79.4293,
    y1: 51.8615,
    x2: 82.791,
    y2: 65.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C41926",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#C01A27",
    stopOpacity: 0.176
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3761,
    stopColor: "#B21E29",
    stopOpacity: 0.376
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5886,
    stopColor: "#9B242C",
    stopOpacity: 0.589
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8079,
    stopColor: "#7B2D31",
    stopOpacity: 0.808
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593636"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_331_15535",
    x1: 74.5326,
    y1: 54.3069,
    x2: 77.6543,
    y2: 53.5402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_331_15535",
    x1: 72.6229,
    y1: 58.2525,
    x2: 75.1943,
    y2: 56.3219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_331_15535",
    x1: 80.6151,
    y1: 50.2362,
    x2: 78.6846,
    y2: 52.8076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_331_15535",
    x1: 82.0547,
    y1: 61.8367,
    x2: 82.8213,
    y2: 58.7148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_331_15535",
    x1: 78.1085,
    y1: 63.7584,
    x2: 80.0392,
    y2: 61.1869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_331_15535",
    x1: 86.1245,
    y1: 55.7684,
    x2: 83.553,
    y2: 57.6991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_331_15535",
    x1: 79.2705,
    y1: 57.0687,
    x2: 71.4807,
    y2: 64.8584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C41926",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#C01A27",
    stopOpacity: 0.176
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3761,
    stopColor: "#B21E29",
    stopOpacity: 0.376
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5886,
    stopColor: "#9B242C",
    stopOpacity: 0.589
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8079,
    stopColor: "#7B2D31",
    stopOpacity: 0.808
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593636"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_331_15535",
    x1: 79.3663,
    y1: 57.1211,
    x2: 79.3663,
    y2: 68.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C41926",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#C01A27",
    stopOpacity: 0.176
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3761,
    stopColor: "#B21E29",
    stopOpacity: 0.376
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5886,
    stopColor: "#9B242C",
    stopOpacity: 0.589
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8079,
    stopColor: "#7B2D31",
    stopOpacity: 0.808
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593636"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_331_15535",
    x1: 56.2092,
    y1: 65.2121,
    x2: 75.4227,
    y2: 84.4259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDFCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_331_15535",
    x1: 71.4404,
    y1: 80.4433,
    x2: 55.9104,
    y2: 64.9133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDFCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_331_15535",
    x1: 35.4517,
    y1: 65.812,
    x2: 35.4518,
    y2: 71.0639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_331_15535",
    x1: 35.6481,
    y1: 68.2437,
    x2: 38.6902,
    y2: 71.2857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3174,
    stopColor: "#3B373B",
    stopOpacity: 0.317
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8224,
    stopColor: "#242324",
    stopOpacity: 0.822
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_331_15535",
    x1: 35.432,
    y1: 68.1582,
    x2: 34.8438,
    y2: 70.7727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3174,
    stopColor: "#3B373B",
    stopOpacity: 0.317
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8224,
    stopColor: "#242324",
    stopOpacity: 0.822
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_331_15535",
    x1: 43.3976,
    y1: 62.8842,
    x2: 51.9124,
    y2: 71.3987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E41F2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_331_15535",
    x1: 34.1001,
    y1: 60.1504,
    x2: 49.1491,
    y2: 69.3171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C41926",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#C01A27",
    stopOpacity: 0.176
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3761,
    stopColor: "#B21E29",
    stopOpacity: 0.376
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5886,
    stopColor: "#9B242C",
    stopOpacity: 0.589
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8079,
    stopColor: "#7B2D31",
    stopOpacity: 0.808
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593636"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_331_15535",
    x1: 43.4408,
    y1: 62.8361,
    x2: 55.4996,
    y2: 70.1401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C41926",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#C01A27",
    stopOpacity: 0.176
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3761,
    stopColor: "#B21E29",
    stopOpacity: 0.376
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5886,
    stopColor: "#9B242C",
    stopOpacity: 0.589
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8079,
    stopColor: "#7B2D31",
    stopOpacity: 0.808
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593636"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_331_15535",
    x1: 41.692,
    y1: 68.0207,
    x2: 43.3577,
    y2: 65.2707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_331_15535",
    x1: 43.1399,
    y1: 72.1512,
    x2: 43.5944,
    y2: 68.9682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_331_15535",
    x1: 43.1748,
    y1: 60.8693,
    x2: 43.6292,
    y2: 64.0522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_331_15535",
    x1: 52.3364,
    y1: 68.0207,
    x2: 50.671,
    y2: 65.2707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_331_15535",
    x1: 50.876,
    y1: 72.1745,
    x2: 50.4216,
    y2: 68.9916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_331_15535",
    x1: 50.841,
    y1: 60.846,
    x2: 50.3867,
    y2: 64.0289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_331_15535",
    x1: 47.0167,
    y1: 66.6252,
    x2: 47.0167,
    y2: 77.6435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C41926",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#C01A27",
    stopOpacity: 0.176
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3761,
    stopColor: "#B21E29",
    stopOpacity: 0.376
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5886,
    stopColor: "#9B242C",
    stopOpacity: 0.589
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8079,
    stopColor: "#7B2D31",
    stopOpacity: 0.808
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593636"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_331_15535",
    x1: 47.1695,
    y1: 66.5436,
    x2: 55.3692,
    y2: 74.7433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C41926",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#C01A27",
    stopOpacity: 0.176
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3761,
    stopColor: "#B21E29",
    stopOpacity: 0.376
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5886,
    stopColor: "#9B242C",
    stopOpacity: 0.589
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8079,
    stopColor: "#7B2D31",
    stopOpacity: 0.808
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593636"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_331_15535",
    x1: 45.1483,
    y1: 64.5294,
    x2: 52.5986,
    y2: 71.9796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_331_15535",
    x1: 51.0083,
    y1: 70.3911,
    x2: 46.2307,
    y2: 65.6134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1766,
    stopColor: "#FDA116",
    stopOpacity: 0.177
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3939,
    stopColor: "#FA921D",
    stopOpacity: 0.394
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6325,
    stopColor: "#F4792A",
    stopOpacity: 0.633
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8846,
    stopColor: "#ED573B",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_331_15535",
    x1: 91.9051,
    y1: 55.5362,
    x2: 84.4548,
    y2: 62.9864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_331_15535",
    x1: 86.0463,
    y1: 61.3902,
    x2: 90.824,
    y2: 56.6125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1766,
    stopColor: "#FDA116",
    stopOpacity: 0.177
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3939,
    stopColor: "#FA921D",
    stopOpacity: 0.394
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6325,
    stopColor: "#F4792A",
    stopOpacity: 0.633
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8846,
    stopColor: "#ED573B",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_331_15535",
    x1: 81.8002,
    y1: 63.8673,
    x2: 87.4843,
    y2: 76.1744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2E62E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1231,
    stopColor: "#97DE30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3395,
    stopColor: "#79CB36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6234,
    stopColor: "#4AAB3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9609,
    stopColor: "#09804C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#017B4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_331_15535",
    x1: 90.0543,
    y1: 67.5323,
    x2: 95.9854,
    y2: 69.6082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    stopColor: "#046842",
    stopOpacity: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#0E6546",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#1D614C",
    stopOpacity: 0.748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#335C54",
    stopOpacity: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_331_15535",
    x1: 84.0782,
    y1: 68.7393,
    x2: 84.0782,
    y2: 71.7488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    stopColor: "#046842",
    stopOpacity: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#0E6546",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#1D614C",
    stopOpacity: 0.748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#335C54",
    stopOpacity: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_331_15535",
    x1: 82.8689,
    y1: 63.5409,
    x2: 77.6628,
    y2: 64.5624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    stopColor: "#046842",
    stopOpacity: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#0E6546",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#1D614C",
    stopOpacity: 0.748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#335C54",
    stopOpacity: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_331_15535",
    x1: 86.8655,
    y1: 72.3317,
    x2: 81.4945,
    y2: 70.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    stopColor: "#046842",
    stopOpacity: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#0E6546",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#1D614C",
    stopOpacity: 0.748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#335C54",
    stopOpacity: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_331_15535",
    x1: 90.096,
    y1: 66.4257,
    x2: 90.096,
    y2: 62.9975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    stopColor: "#046842",
    stopOpacity: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#0E6546",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#1D614C",
    stopOpacity: 0.748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#335C54",
    stopOpacity: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_331_15535",
    x1: 74.0797,
    y1: 66.1988,
    x2: 74.0797,
    y2: 71.4505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_331_15535",
    x1: 73.8829,
    y1: 68.6304,
    x2: 70.841,
    y2: 71.6723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3174,
    stopColor: "#3B373B",
    stopOpacity: 0.317
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8224,
    stopColor: "#242324",
    stopOpacity: 0.822
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_331_15535",
    x1: 74.1079,
    y1: 68.5527,
    x2: 74.6962,
    y2: 71.1672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3174,
    stopColor: "#3B373B",
    stopOpacity: 0.317
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8224,
    stopColor: "#242324",
    stopOpacity: 0.822
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_331_15535",
    x1: 15.8499,
    y1: 46.2871,
    x2: 16.765,
    y2: 72.5616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2E62E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1231,
    stopColor: "#97DE30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3395,
    stopColor: "#79CB36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6234,
    stopColor: "#4AAB3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9609,
    stopColor: "#09804C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#017B4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_331_15535",
    x1: 22.8665,
    y1: 63.7415,
    x2: 16.6572,
    y2: 78.5782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    stopColor: "#046842",
    stopOpacity: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#0E6546",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#1D614C",
    stopOpacity: 0.748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#335C54",
    stopOpacity: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_331_15535",
    x1: 10.505,
    y1: 56.2783,
    x2: 21.0932,
    y2: 81.5724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    stopColor: "#046842",
    stopOpacity: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#0E6546",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#1D614C",
    stopOpacity: 0.748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#335C54",
    stopOpacity: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_331_15535",
    x1: 7.78564,
    y1: 51.963,
    x2: 17.7856,
    y2: 73.3356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    stopColor: "#046842",
    stopOpacity: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#0E6546",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#1D614C",
    stopOpacity: 0.748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#335C54",
    stopOpacity: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_331_15535",
    x1: 5.95209,
    y1: 49.9944,
    x2: 12.1611,
    y2: 63.4585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    stopColor: "#046842",
    stopOpacity: 0.324
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5509,
    stopColor: "#0E6546",
    stopOpacity: 0.551
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7476,
    stopColor: "#1D614C",
    stopOpacity: 0.748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#335C54",
    stopOpacity: 0.926
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_331_15535",
    x1: 21.1287,
    y1: 65.726,
    x2: 13.6784,
    y2: 73.1763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_331_15535",
    x1: 15.2702,
    y1: 71.5878,
    x2: 20.0478,
    y2: 66.8102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1766,
    stopColor: "#FDA116",
    stopOpacity: 0.177
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3939,
    stopColor: "#FA921D",
    stopOpacity: 0.394
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6325,
    stopColor: "#F4792A",
    stopOpacity: 0.633
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8846,
    stopColor: "#ED573B",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_331_15535",
    x1: 49.8096,
    y1: 75.4386,
    x2: 53.2476,
    y2: 96.4966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_331_15535",
    x1: 49.9985,
    y1: 85.1598,
    x2: 49.9985,
    y2: 93.4631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3DAFE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1327,
    stopColor: "#ACD8FE",
    stopOpacity: 0.133
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3208,
    stopColor: "#9AD1FE",
    stopOpacity: 0.321
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5418,
    stopColor: "#7BC5FE",
    stopOpacity: 0.542
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7859,
    stopColor: "#51B6FE",
    stopOpacity: 0.786
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26A6FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_331_15535",
    x1: 83.4466,
    y1: 89.4121,
    x2: 91.0606,
    y2: 93.8654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3DAFE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1327,
    stopColor: "#ACD8FE",
    stopOpacity: 0.133
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3208,
    stopColor: "#9AD1FE",
    stopOpacity: 0.321
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5418,
    stopColor: "#7BC5FE",
    stopOpacity: 0.542
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7859,
    stopColor: "#51B6FE",
    stopOpacity: 0.786
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26A6FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_331_15535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.c3db8ed1ab5275e7a416cb294c5a4cd9.svg";
export { ForwardRef as ReactComponent };